import request from './request'

/**
 * 客户端仅保留「读取默认模型」这一只读接口。
 * 模型配置管理已迁移到管理端 zxsy-admin-pc（/llms 写操作仅平台 staff/admin 可调）。
 */

/** 当前默认 对话/图片/视频 模型 */
export function fetchDefaults() {
  return request.get('/llms/defaults')
}

/** 模型列表（含每个视频模型的积分单价 video_points_per_second），用于前端预估积分 */
export function fetchLlms() {
  return request.get('/llms')
}
